import React from 'react';
import { Div } from '../../box';

export const Main = ({ children, isNewNavigation }: { isNewNavigation?: boolean; children?: React.ReactNode }) => {
  return (
    <Div
      componentClass={'main'}
      paddingLeft={isNewNavigation ? '2xxl' : undefined}
      overflowY={'auto'}
      id={'main-content'}
      height={'100%'}
    >
      {children}
    </Div>
  );
};
